<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="factory.id ? '编辑' : '新建'"
      width="1200px"
      top="5vh"
      @close="resetForm"
  >
    <el-form
        ref="form"
        :model="factory"
        :rules="ruleValidate"
        label-width="140px"
        label-suffix=" :">
      <div class="fm-section-title">编码标识</div>
      <el-row :gutter="10">
        <el-col v-if="factory.id" :span="6">
          <el-form-item label="工厂编码">
            <el-input v-model="factory.factoryCode" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工厂全称" prop="factoryName">
            <el-input v-model="factory.factoryName"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工厂简称">
            <el-input v-model="factory.factoryShortName"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工厂别名">
            <el-input v-model="factory.factoryAlias"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="英文名称">
            <el-input v-model="factory.factoryEnglishName"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="ERP组织编码">
            <el-input v-model="factory.factoryERPOrgCode"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="WMS编码">
            <el-input v-model="factory.factoryWMSCode"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="WCS编码">
            <el-input v-model="factory.factoryWCSCode"/>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">类型与经营资质</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="工厂类型" prop="factoryType">
            <el-select v-model="factory.factoryType" clearable>
              <el-option v-for="item in factoryTypeOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="企业性质">
            <el-select v-model="factory.factoryNature" clearable>
              <el-option v-for="item in factoryNatureOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工厂状态" prop="factoryStatus">
            <el-select v-model="factory.factoryStatus" clearable>
              <el-option v-for="item in factoryStatusOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="社会信用代码">
            <el-input v-model="factory.businessLicenseNo"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="生产许可证号">
            <el-input v-model="factory.productionLicenseNo"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="环评排污许可证">
            <el-input v-model="factory.environmentalPermitNo"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="消防验收备案">
            <el-input v-model="factory.fireControlNo"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="ISO9001认证">
            <el-radio-group v-model="factory.iso9001">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="ISO14001认证">
            <el-radio-group v-model="factory.iso14001">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="IATF16949认证">
            <el-radio-group v-model="factory.iatf16949">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">地址与区位</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="省份">
            <el-input v-model="factory.province"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="城市">
            <el-input v-model="factory.city"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="区县">
            <el-input v-model="factory.district"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="乡镇/街道">
            <el-input v-model="factory.town"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址">
            <el-input v-model="factory.detailedAddress"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="邮政编码">
            <el-input v-model="factory.postalCode"/>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">负责人与联络</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="企业法人">
            <el-input v-model="factory.legalPerson"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="厂长/负责人">
            <el-input v-model="factory.factoryDirector"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="行政对接人">
            <el-input v-model="factory.adminContact"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="生产负责人">
            <el-input v-model="factory.productionContact"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="质量负责人">
            <el-input v-model="factory.qualityContact"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="IT运维对接人">
            <el-input v-model="factory.itContact"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="总机电话">
            <el-input v-model="factory.phoneMain"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="厂长手机">
            <el-input v-model="factory.phoneDirector"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="生产负责人手机">
            <el-input v-model="factory.phoneProduction"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="对外邮箱">
            <el-input v-model="factory.emailFactory"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="传真号码">
            <el-input v-model="factory.fax"/>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">产能与生产规划</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="主营产品">
            <el-input v-model="factory.mainProduct"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="标准日产量">
            <el-input-number v-model="factory.standardDailyCapacity" :min="0" controls-position="right"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="标准年产能">
            <el-input-number v-model="factory.standardYearCapacity" :min="0" controls-position="right"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="全年生产天数">
            <el-input-number v-model="factory.workDayYear" :min="0" :max="366" controls-position="right"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="默认开班班次">
            <el-select v-model="factory.standardShiftCount" clearable>
              <el-option v-for="item in shiftCountOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="最大容纳人数">
            <el-input-number v-model="factory.maxWorkerCount" :min="0" controls-position="right"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="当前在岗人数">
            <el-input-number v-model="factory.currentWorkerCount" :min="0" controls-position="right"/>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">系统通讯配置</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="MES服务器IP">
            <el-input v-model="factory.factoryServerIP"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="服务端口">
            <el-input-number v-model="factory.factoryServerPort" :min="0" :max="65535" controls-position="right"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="OPC UA地址">
            <el-input v-model="factory.opcuaServerAddr"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="时区">
            <el-input v-model="factory.timeZone"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="数据同步">
            <el-radio-group v-model="factory.dataSyncSwitch">
              <el-radio :label="true">开启</el-radio>
              <el-radio :label="false">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="同步间隔(分钟)">
            <el-input-number v-model="factory.syncIntervalMin" :min="1" controls-position="right"/>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">启用时间</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="动工日期">
            <el-date-picker v-model="factory.buildStartDate" type="date" value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="投产日期">
            <el-date-picker v-model="factory.productionStartDate" type="date" value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="停产日期">
            <el-date-picker v-model="factory.stopProductionDate" type="date" value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">运维备注</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="工厂综合备注">
            <el-input v-model="factory.factoryRemark" type="textarea" :rows="2"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="仓储配套说明">
            <el-input v-model="factory.storageRemark" type="textarea" :rows="2"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="大型设备配套说明">
            <el-input v-model="factory.equipmentRemark" type="textarea" :rows="2"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物流/AGV配套说明">
            <el-input v-model="factory.transportRemark" type="textarea" :rows="2"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        factoryTypeOptions: [
          { label: "自有生产厂", value: 1 },
          { label: "委外代工厂", value: 2 },
          { label: "仓储中转基地", value: 3 },
          { label: "研发试制基地", value: 4 },
        ],
        factoryNatureOptions: [
          { label: "内资", value: 1 },
          { label: "外资", value: 2 },
          { label: "合资", value: 3 },
        ],
        factoryStatusOptions: [
          { label: "筹建", value: 0 },
          { label: "正常生产", value: 1 },
          { label: "临时停产", value: 2 },
          { label: "永久关停", value: 3 },
        ],
        shiftCountOptions: [
          { label: "白班", value: 1 },
          { label: "两班", value: 2 },
          { label: "三班", value: 3 },
        ],
        factory: {},
        ruleValidate: {
          factoryName: { required: true, message: "请输入工厂全称", trigger: "blur" },
          factoryType: { required: true, message: "请选择工厂类型", trigger: "change" },
          factoryStatus: { required: true, message: "请选择工厂状态", trigger: "change" },
        },
      };
    },
    methods: {
      resetForm() {
        this.$refs.form && this.$refs.form.resetFields();
      },
      open(row) {
        this.dialogVisible = true;
        this.factory = Object.assign(
          {
            id: undefined,
            factoryCode: "",
            factoryName: "",
            factoryShortName: "",
            factoryAlias: "",
            factoryEnglishName: "",
            factoryERPOrgCode: "",
            factoryWMSCode: "",
            factoryWCSCode: "",
            factoryType: 1,
            factoryNature: 1,
            factoryStatus: 1,
            businessLicenseNo: "",
            productionLicenseNo: "",
            environmentalPermitNo: "",
            fireControlNo: "",
            iso9001: false,
            iso14001: false,
            iatf16949: false,
            province: "",
            city: "",
            district: "",
            town: "",
            detailedAddress: "",
            postalCode: "",
            legalPerson: "",
            factoryDirector: "",
            adminContact: "",
            productionContact: "",
            qualityContact: "",
            itContact: "",
            phoneMain: "",
            phoneDirector: "",
            phoneProduction: "",
            emailFactory: "",
            fax: "",
            mainProduct: "",
            standardDailyCapacity: undefined,
            standardYearCapacity: undefined,
            workDayYear: undefined,
            standardShiftCount: 1,
            maxWorkerCount: undefined,
            currentWorkerCount: undefined,
            factoryServerIP: "",
            factoryServerPort: undefined,
            opcuaServerAddr: "",
            timeZone: "UTC+8",
            dataSyncSwitch: true,
            syncIntervalMin: 30,
            buildStartDate: "",
            productionStartDate: "",
            stopProductionDate: "",
            factoryRemark: "",
            storageRemark: "",
            equipmentRemark: "",
            transportRemark: "",
          },
          row || {}
        );
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "fm/factory-manger", this.factory)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success(this.factory.id ? "编辑成功" : "添加成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>
.fm-section-title {
  font-weight: bold;
  padding: 10px 0 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
  color: #409eff;
}
</style>
